import { render, staticRenderFns } from "./RentalOfPremises.vue?vue&type=template&id=422220b7&scoped=true"
import script from "./RentalOfPremises.vue?vue&type=script&lang=js"
export * from "./RentalOfPremises.vue?vue&type=script&lang=js"
import style0 from "./RentalOfPremises.vue?vue&type=style&index=0&id=422220b7&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422220b7",
  null
  
)

export default component.exports